import { render, staticRenderFns } from "./yourStaffProgress.vue?vue&type=template&id=5a88f8d4&"
import script from "./yourStaffProgress.vue?vue&type=script&lang=js&"
export * from "./yourStaffProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports